// styles.js
import styled from "styled-components";

export const LoginContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
    align-items: flex-start;
    padding-top: 2rem;
  }
`;

export const LoginCard = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
  padding: 24px 40px;
  width: 100%;
  max-width: 500px;
  backdrop-filter: blur(10px);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  @media (max-width: 768px) {
    padding: 30px 20px;
    max-width: 100%;
    border-radius: 8px;
    margin: 0 10px;
  }

  @media (max-width: 480px) {
    padding: 25px 15px;
    margin: 0 5px;
  }
`;

export const Title = styled.h1`
  color: #333;
  font-size: 2.2rem;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: 700;
  position: relative;

  &:after {
    content: "";
    display: block;
    width: 50px;
    height: 4px;
    background: linear-gradient(90deg, #667eea, #764ba2);
    margin: 8px auto 0;
    border-radius: 2px;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
  border-bottom: 1px solid #e1e1e1;
`;

export const Tab = styled.button`
  flex: 1;
  padding: 12px 20px;
  background: none;
  border: none;
  font-size: 1rem;
  font-weight: 600;
  color: ${({ active }) => (active ? "#764ba2" : "#666")};
  cursor: pointer;
  position: relative;

  &:after {
    content: "";
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 100%;
    height: 3px;
    background: ${({ active }) =>
      active ? "linear-gradient(90deg, #667eea, #764ba2)" : "transparent"};
  }

  &:hover {
    color: #764ba2;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

export const Label = styled.label`
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const Input = styled.input`
  padding: 12px 16px;
  border: 1px solid #e1e1e1;
  width: 100%;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background-color: #f9f9f9;

  &:focus {
    outline: none;
    border-color: #764ba2;
    box-shadow: 0 0 0 2px rgba(118, 75, 162, 0.2);
    background-color: #fff;
  }
`;

export const PasswordWrapper = styled.div`
  position: relative;
`;

export const EyeIcon = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #666;
  font-size: 1.2rem;
  user-select: none;
  padding: 4px;

  &:hover {
    color: #764ba2;
  }
`;

export const ValidationList = styled.div`
  margin-top: 0.5rem;
  padding: 0.75rem;
  background: #f9f9f9;
  border-radius: 6px;
  font-size: 0.8rem;
  border: 1px solid #e1e1e1;
`;

export const ValidationItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0;
  color: ${({ isValid }) => (isValid ? "#4caf50" : "#666")};

  &:before {
    content: "${({ isValid }) => (isValid ? "✓" : "○")}";
    margin-right: 8px;
    font-size: 0.9rem;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ErrorMessage = styled.div`
  color: #e53935;
  padding: 12px;
  background-color: rgba(229, 57, 53, 0.1);
  border-radius: 8px;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;

  &:before {
    content: "⚠️";
    margin-right: 8px;
    font-size: 1rem;
  }
`;

export const SuccessMessage = styled.div`
  color: #4caf50;
  padding: 12px;
  background-color: rgba(76, 175, 80, 0.1);
  border-radius: 8px;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  display: flex;
  align-items: center;

  &:before {
    content: "✓";
    margin-right: 8px;
    font-size: 1rem;
    font-weight: bold;
  }
`;

export const SubmitButton = styled.button`
  background: linear-gradient(90deg, #667eea, #764ba2);
  color: white;
  border: none;
  padding: 14px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 6px rgba(102, 126, 234, 0.25);
  transition: all 0.3s ease;
  margin-top: 1rem;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 7px 10px rgba(102, 126, 234, 0.35);
  }

  &:active {
    transform: translateY(1px);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }
`;

export const LogoImg = styled.img`
  display: block;
  margin: 0 auto 20px;
  height: 35px;
`;

// Add these to your existing Login.styles.js
export const BackToLogin = styled.button`
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-size: 14px;
  margin-top: 15px;
  text-align: center;
  width: 100%;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: #999;
    cursor: not-allowed;
  }
`;

export const InstructionText = styled.p`
  color: #666;
  font-size: 14px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 1.5;
`;

export const ResendButton = styled.button`
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  font-size: 14px;
  padding: 8px 16px;
  width: 100%;

  &:hover:not(:disabled) {
    background: #e9ecef;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CountdownText = styled.span`
  color: #666;
  font-size: 13px;
  display: block;
  margin-top: 5px;
`;
